<template>
  <a v-if="user">
    <b-dropdown right variant="link" no-caret>
      <template #button-content>
        <UserSvg class="user-svg svg-light"/>
        <span class="user-name d-none d-xl-inline header-title">{{ user.fname }}</span>
      </template>
      <b-dropdown-item v-if="clinic && !superadmin">{{ $t('clinic_id') }}: {{ clinic.id }}</b-dropdown-item>
      <b-dropdown-item v-if="clinic && !superadmin" to="/sessions">{{ $t('sessions') }}</b-dropdown-item>
      <b-dropdown-item v-if="clinic && !superadmin" @click="editMyInfo">{{ $t('edit') }}</b-dropdown-item>
      <b-dropdown-item @click="logout">{{ $t('logout') }}</b-dropdown-item>
      <b-dropdown-divider v-if="clinicId === 1843"></b-dropdown-divider>
      <b-dropdown-item link-class="text-danger" v-if="clinicId === 1843" @click="deleteProfile">{{ $t('delete') }}</b-dropdown-item>
    </b-dropdown>
  </a>
</template>

<script setup>
import UserSvg from '@/assets/svg-vue/header/user.svg'
import { roles } from "@/dictionaries/dictionary"
import { copyObject } from "@/extensions/prototypes/prototypes"
import { computed, getCurrentInstance, watch } from "vue"
import { useStore } from "vuex"
import { useRouter } from "vue-router"

const store = useStore()
const router = useRouter()
const noty = getCurrentInstance()?.appContext?.app?.noty

const user = computed(() => store.state.auth.user)
const clinic = computed(() => store.state.auth.clinic)
const superadmin = computed(() => store.state.auth.superadmin)
const newEloquentObject = computed(() => store.state.datatable.newEloquentObject)

const viewModel = computed(() => roles[user.value.role_id])
const clinicId = computed(() => clinic.value?.id || null)

const logout = async () => {
  await store.dispatch('logout')
  router.push('/login').catch(()=>{})
}

const editMyInfo = () => {
  store.commit('setViewModel', viewModel.value)
  store.commit('setModule', 'staff')
  store.commit('setSelectedModel', copyObject(user.value))
  store.commit('setShowModal', true)
}

const deleteProfile = async () => {
  store.commit('setLoading', true)
  await new Promise(resolve => setTimeout(resolve, 500))
  noty.info('Ваш аккаунт будет удалён через 24 часа')
  store.commit('setLoading', false)
}

// own info saved through the staff form
watch(newEloquentObject, (val) => {
  if(val && val.id == user.value.id && val.model_name == viewModel.value) {
    store.commit('setUser', copyObject(val))
  }
}, { deep: true })
</script>

<style scoped lang="scss">
.dropdown-toggle {
  margin-top: -2px;
}
.user-name {
  top: -1px;
  position: relative;
}
.user-svg {
  top: -2px;
  position: relative;
}
@media screen and (max-width: 768px) {
  .user-svg {
    margin-right: 0;
  }
}
</style>
